import { gql } from "@apollo/client";

export const REQUEST_CONFIRM_PHONE = gql`
  mutation requestConfirmPhone {
    requestConfirmPhone
  }
`;
